<script lang="ts">
    export let lang = "de"
    export let value: string
</script>

{#if value?.match(/^\d{6}$/)}
    {lang == "de" ? "KW" : "Week"} {value.replace(/^\d{4}/, "")}
{/if}
